import { useRef, useEffect } from 'react'

export type ImageConfig = {
  rectTop: number // アイテム抽出範囲のtop値
  rectLeft: number // アイテム抽出範囲のleft値
  rectWidth: number // アイテム抽出範囲の幅
  rectHeight: number // アイテム抽出範囲の高さ
}

type Props = {
  img: HTMLImageElement
  config: ImageConfig
}

export const ImageSearchItemImage: React.FC<Props> = ({ img, config }) => {
  const canvasRef = useRef<HTMLCanvasElement>(null)

  // eslint-disable-next-line max-statements
  useEffect(() => {
    // コーデ画像からアイテム画像を正方形に切り抜いてcanvasに設定する
    // アイテム画像を正方形に切り抜くための計算を行う
    let sx = 0 // Souce Image X: 切り抜く範囲のX座標
    let sy = 0 // Souce Image Y: 切り抜く範囲のY座標
    let sl = 0 // Souce Image length: 切り抜く範囲の一辺の長さ
    const diff = config.rectWidth - config.rectHeight
    if (diff > 0) {
      // アイテム抽出範囲が横長の場合
      // 横の長さを正方形の一辺に設定
      sx = config.rectLeft
      sy = config.rectTop - Math.round(diff / 2)
      sl = config.rectWidth
      // 切り抜く正方形のY座標がコーデ画像の縦をはみ出したら範囲を狭める
      // 上にはみ出した場合
      if (sy < 0) {
        const val = -sy
        sx += val
        sy += val
        sl -= val * 2
      }
      // 下にはみ出した場合
      if (sy + sl > img.naturalHeight) {
        const val = sy + sl - img.naturalHeight
        sx += val
        sy += val
        sl -= val * 2
      }
    } else {
      // アイテム抽出範囲が縦長の場合
      // 縦の長さを正方形の一辺に設定
      sx = config.rectLeft + Math.round(diff / 2)
      sy = config.rectTop
      sl = config.rectHeight
      // 切り抜く正方形のX座標がコーデ画像の横をはみ出したら範囲を狭める
      // 左にはみ出した場合
      if (sx < 0) {
        const val = -sx
        sx += val
        sy += val
        sl -= val * 2
      }
      // 右にはみ出した場合
      if (sx + sl > img.naturalWidth) {
        const val = sx + sl - img.naturalWidth
        sx += val
        sy += val
        sl -= val * 2
      }
    }
    const canvas = canvasRef.current
    if (canvas) {
      canvas.width = sl
      canvas.height = sl
      const ctx = canvas.getContext('2d')
      ctx?.drawImage(img, sx, sy, sl, sl, 0, 0, sl, sl)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <canvas
      ref={canvasRef}
      className="size-10 rounded-full border-[0.5px] border-solid border-gray-300"
    />
  )
}
